// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getStorage} from "firebase/storage";
import {getAuth, GoogleAuthProvider, signInWithPopup, onAuthStateChanged, signOut} from "firebase/auth";
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBrdAyREJC4XLqCZKQK-R6iZO0OVTgrHTg",
    authDomain: "cs32-aff78.firebaseapp.com",
    projectId: "cs32-aff78",
    storageBucket: "cs32-aff78.appspot.com",
    messagingSenderId: "623767962146",
    appId: "1:623767962146:web:de31a63545ace4d521007b",
    measurementId: "G-R14ZZE078X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const signedIn = false;
export const storage = getStorage(app);


const provider = new GoogleAuthProvider();

provider.setCustomParameters({
    hd: "brown.edu"
});

// signInWithRedirect requires a full page navigation away and back through
// GitHub Pages' client-side routing, and Firebase's own redirect-completion
// handler does a reachability check against the page you signed in from
// before it'll hand back a signed-in user -- both are extra failure points
// that don't exist for signInWithPopup, which never leaves the page. The
// once-suspected COOP issue with popups traced back to Firebase Hosting
// never having been initialized for this project (see the /__/firebase/init.json
// 404s), which is now fixed, so popup should work cleanly.
export const signInWithGoogle = () => {
    signInWithPopup(auth, provider).catch((error) => {
        console.error("[auth] popup sign-in failed:", error.code, error.message);
    });
}

// PrivateRoute gates access purely on localStorage.getItem("name") rather
// than Firebase's real auth state, so this listener is what actually keeps
// that in sync -- on every state change (sign-in completing, a persisted
// session restoring on reload, or signing out).
onAuthStateChanged(auth, (user) => {
    console.log("[auth] state changed:", user ? user.email : null);
    if (user) {
        localStorage.setItem("name", user.displayName);
        localStorage.setItem("email", user.email);
        localStorage.setItem("photo", user.photoURL);
    } else {
        localStorage.removeItem("name");
        localStorage.removeItem("email");
        localStorage.removeItem("photo");
    }
});

export const signOutWithGoogle = () =>{
    signOut(auth).then(() => {
        localStorage.clear();
        console.log("Sign out successful");
    }).catch((error)=> {
            console.log("ERROR: "+error);
        });
}
